import React from 'react';
import { MdPerson } from 'react-icons/md';
import { PaginaDeportes } from '../_shared';
import TablaDeportistas from './TablaDeportistas';

const Deportistas: React.FC = () => (
  <PaginaDeportes
    icon={MdPerson}
    titulo="Deportistas"
    subtitulo="Registro y seguimiento de deportistas del municipio"
  >
    <TablaDeportistas />
  </PaginaDeportes>
);

export default Deportistas;
